import { render, staticRenderFns } from "./tabHBL2UICustomLayout.vue?vue&type=template&id=3c21338e&"
import script from "./tabHBL2UICustomLayout.vue?vue&type=script&lang=js&"
export * from "./tabHBL2UICustomLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c21338e')) {
      api.createRecord('3c21338e', component.options)
    } else {
      api.reload('3c21338e', component.options)
    }
    module.hot.accept("./tabHBL2UICustomLayout.vue?vue&type=template&id=3c21338e&", function () {
      api.rerender('3c21338e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabHBL2UICustomLayout.vue"
export default component.exports